import Service, { service } from '@ember/service';
import type AjaxFetchService from 'garaje/services/ajax-fetch';
import urlBuilder from 'garaje/utils/url-builder';

interface CreateLeadParams {
  email: string;
  name: string;
  leadSource: string;
}

export default class SalesforceLeadsService extends Service {
  @service declare ajaxFetch: AjaxFetchService;

  async createLead({ email, name, leadSource }: CreateLeadParams): Promise<void> {
    const data = {
      data: {
        type: 'salesforce-leads',
        attributes: {
          email,
          'lead-source': leadSource,
          name,
        },
      },
    };

    await this.ajaxFetch.post(urlBuilder.v3.salesforceLeads.createUrl(), {
      contentType: 'application/vnd.api+json',
      data,
    });
  }
}

declare module '@ember/service' {
  interface Registry {
    'salesforce-leads': SalesforceLeadsService;
  }
}
